export enum PaymentType {
  Card2Card = 'card2card',
  TCard2Card = 'tcard2card',
  SBP = 'sbp',
  TSBP = 'tsbp',
  SberPay = 'sberpay',
  AccountNumber = 'account_number',
  PhoneNumber = 'phone_number',
  SIM = 'sim',
  TransferViaIdCard = 'transfer_via_id_card',
  AccountNumberIBAN = 'account_number_iban',
  AccountNumberSEPA = 'account_number_sepa',
  UPI = 'upi',
  IMPS = 'imps',
  PhonePE = 'phone_pe',
  ERIP = 'erip',
  PaymentLink = 'payment_link',
  NSPK = 'nspk',
}
